<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t("message.Каналы_источников") }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t("message.Главная") }}</router-link>
          </li>
          <li class="active breadcrumb-item">
            {{ $t("message.Каналы_источников") }}
          </li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper">
      <b-row>
        <b-col class="text-right">
          <b-form-group
            :label="$t('message.Источник_для_отображения_каналов')"
            label-for="Sources"
          >
            <v-select
              v-model="EPG_SelectedSource"
              :options="this.EPG_Sources"
              label="name"
              class="d-inline-block"
              style="width:300px;"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        id="device-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        ref="ChannelsTable"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="actions" slot-scope="row">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button
            size="sm"
            @click.stop="deleteRow(row.item, row.index, $event.target)"
          >
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "EPG_Channel",

  data() {
    return {
      isBusy: false,
      fields: [
        { key: "id", sortable: true },
        { key: "name", sortable: true },
        { key: "alive", sortable: false }
      ],
      EPG_Sources: [],
      EPG_SelectedSource: null,
      EPG_SelectedSourceId: null,
      perPage: 10,
      currentPage: 1,
      totalRows: 0
    };
  },
  methods: {
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      //console.log(ctx)
      if (!this.EPG_SelectedSource && !this.EPG_SelectedSourceId) {
        return [];
      }

      let Sources = this.$noname.getChild(
        "epg_sources",
        this.EPG_SelectedSource
          ? this.EPG_SelectedSource.id
          : this.EPG_SelectedSourceId,
        "epgchannels",
        { params: ctx }
      );

      return Sources.then(data => {
        const items = data.data.items;
        this.totalRows = data.data.total;

        // Here we could override the busy state, setting isBusy to false
        // this.isBusy = false
        return items;
      }).catch(this.$noname.HandleError);
    },

    resetModal() {}
  },
  created() {
    this.EPG_SelectedSourceId = this.$route.params.source_id;

    let Sources = this.$noname.get("epg_sources");
    Sources.then(data => {
      this.EPG_Sources = data.data.items;
      if (this.EPG_SelectedSourceId) {
        let EPG_Id = this.EPG_SelectedSourceId;
        this.EPG_SelectedSource = this.EPG_Sources.filter(function(key) {
          return key.id == EPG_Id;
        })[0];
      }
    }).catch(this.$noname.HandleError);
  },
  watch: {
    EPG_SelectedSource() {
      this.$root.$emit("bv::refresh::table", "device-table");
      //this.$refs.ChannelsTable.refresh();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/EPG_Channels.vue